<template>
    <div>

    </div>
</template>
<script>
export default {
    mounted() {
        // window.open('https://42.159.81.209:8080/UltraLTS/');
        // window.location.href = 'https://42.159.81.209:8080/UltraLTS/'
        window.location.href = 'https://www.seicdc.com/siemens?pv=56563edf23b9d717dc63981b8836fc60'
    }
}
</script>